import request from '../../axios/axiosconfig'

/**
 * 查询PC管理人员列表
 * @param {params}  
 * @returns 
 */
export function getPcUser(params) {
  return request({
    url: '/ps/pcManager/getPcUser',
    method: 'get',
    params: params
  })
}

/**
 * 查询职位
 * @returns 
 */
 export function getPosition() {
  return request({
    url: '/ps/pcManager/getPosition',
    method: 'get'
  })
}

/**
 * 添加职位永华
 * @returns 
 */
 export function addPcManager(data) {
  return request({
    url: '/ps/pcManager/addPcManager',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/sys/pcManager.js